import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import LvMap, { SYM_LV_MAP } from "../map/LvMap.vue";
export const COMPONENT_NAME = "LvMapMarker";
/**
 * A marker of the map.
 */
let LvMapMarker = class LvMapMarker extends UIComponent {
    constructor() {
        super(...arguments);
        this.markerInstance = null;
    }
    /**
     * Instance of the native marker
     */
    get marker() {
        return this.markerInstance;
    }
    mounted() {
        this.createMarker();
    }
    createMarker() {
        if (!this.mapComponent.map) {
            console.warn("Map should exist");
            return;
        }
        this.markerInstance = new google.maps.Marker({
            ...this.options,
            map: this.mapComponent.map,
        });
    }
};
__decorate([
    Inject(SYM_LV_MAP),
    __metadata("design:type", LvMap)
], LvMapMarker.prototype, "mapComponent", void 0);
__decorate([
    Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], LvMapMarker.prototype, "options", void 0);
LvMapMarker = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvMapMarker);
export default LvMapMarker;
//# sourceMappingURL=script.js.map